// extracted by mini-css-extract-plugin
export default {"nav":"header_nav__5WCG0"};